var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d4e6d144522325138284a6b71b52c4b029451b22"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["fe-partner-service@porter-a7"]={id:"d4e6d144522325138284a6b71b52c4b029451b22"};
      